<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <div class="form-group">
        <input class="form-control" placeholder="{{data.placeholder}}" [(ngModel)]="data.item"/>
    </div>
</div>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-button [mat-dialog-close]="data.item" cdkFocusInitial>Ok</button>
</mat-dialog-actions>